.block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-3);
  max-width: 420px;
  margin: 0 auto;
  padding: var(--space-12) var(--space-4);
  text-align: center;
}

.badge,
.badgeDanger {
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  margin-bottom: var(--space-1);
  border-radius: var(--radius-full);
}

.badge {
  background: var(--color-accent-soft);
  color: var(--color-accent-text);
}

.badgeDanger {
  background: var(--color-danger-soft);
  color: var(--color-danger-text);
}

.title {
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-snug);
  overflow-wrap: anywhere;
}

.description {
  color: var(--color-text-muted);
  line-height: var(--leading-normal);
}

.action {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2);
  margin-top: var(--space-2);
}
